"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Item = void 0;
const react_1 = __importDefault(require("react"));
const TimelineSeparator_1 = __importDefault(require("@mui/lab/TimelineSeparator"));
const TimelineContent_1 = __importDefault(require("@mui/lab/TimelineContent"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Update_svg_1 = __importDefault(require("@/assets/Update.svg"));
const Exclamation_svg_1 = __importDefault(require("@/assets/Exclamation.svg"));
const TrashCan_svg_1 = __importDefault(require("@/assets/TrashCan.svg"));
const style_1 = require("./style");
const ScrollingLoader_1 = __importDefault(require("../ScrollingLoader"));
function ChangeLog({ changelogItems, loadMoreRef, hasDataEnded, }) {
    return (react_1.default.createElement(style_1.ChangeLogWrapper, { id: "changelog" },
        react_1.default.createElement(style_1.ChangelogTitle, { variant: "h4" }, "Changelog"),
        react_1.default.createElement(style_1.StyledTimeline, { position: "right" }, changelogItems.map((item, i) => {
            return react_1.default.createElement(exports.Item, { data: item, key: i });
        })),
        !hasDataEnded ? (react_1.default.createElement("span", { ref: loadMoreRef, style: { display: "flex", justifyContent: "center" } },
            react_1.default.createElement(ScrollingLoader_1.default, null))) : (react_1.default.createElement("span", { style: { display: "flex", justifyContent: "center" } },
            react_1.default.createElement(Typography_1.default, { variant: "body2" },
                " ",
                react_1.default.createElement("strong", null, "No records found."))))));
}
exports.default = ChangeLog;
const Item = ({ data }) => {
    const [date, time] = data?.logDate.split("|");
    return (react_1.default.createElement(style_1.StyledTimelineItem, null,
        react_1.default.createElement(TimelineSeparator_1.default, null,
            react_1.default.createElement(style_1.CustomDot, null,
                data.operation === "UPDATE" && react_1.default.createElement("img", { src: Update_svg_1.default }),
                data.operation === "CREATE" && react_1.default.createElement("img", { src: Exclamation_svg_1.default }),
                data.operation === "DELETE" && react_1.default.createElement("img", { src: TrashCan_svg_1.default })),
            react_1.default.createElement(style_1.StyledConnector, null)),
        react_1.default.createElement(TimelineContent_1.default, null,
            react_1.default.createElement(style_1.OperationWrapper, null,
                react_1.default.createElement(style_1.OperationTitle, { variant: "h4" }, data.operationTitle),
                react_1.default.createElement(style_1.AffectedEntityName, { variant: "body1" }, data.affectedEntityName)),
            react_1.default.createElement(style_1.DateWrapper, null,
                react_1.default.createElement(style_1.ChangeLogDate, { variant: "body1" }, date),
                react_1.default.createElement("span", { style: { color: "#E0E0E0" } }, "|"),
                react_1.default.createElement(style_1.ChangeLogTime, { variant: "body1" }, time)),
            react_1.default.createElement(style_1.User, null, data.user))));
};
exports.Item = Item;
